import {HTTP_INTERCEPTORS} from '@angular/common/http'
import {AuthInterceptor} from './auth.interceptor'
import {I18nInterceptor} from './i18n.interceptor'
import {ErrorInterceptor} from './error.interceptor'
import {PreventInterceptor} from './prevent.interceptor'
import {Provider} from '@angular/core'

export const provideHttpInterceptors: () => Provider[] = () => [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: I18nInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: PreventInterceptor, // this interceptor must always be the last, as it's cleaning up the prevent header
    multi: true,
  },
]
